<div class="container flex flex-col items-center">
	<input class="hidden" type="file" (change)="handleFileInput($event.target.files)" name="file" id="file">
	<img class="object-cover w-40 h-40 rounded-full " [src]="previewSrc || DEFAULT_AVATAR" alt="Foto">

	<div class="w-56 mt-4">
		<label class="cursor-pointer edu-btn edu-btn-secondary" for="file">Enviar arquivo</label>
		<span *ngIf="errorMessage" class="inline-block w-full mt-1 text-sm text-justify text-edu-red font-dinosaur min-w-min">{{ errorMessage }}</span>
	</div>
</div>
